import { useIsMobile } from "@/hooks/use-is-mobile"
import { useEffect, useRef } from "react"

const SpotFood = () => {
  const { isMobile } = useIsMobile()

  const videoRef = useRef<HTMLVideoElement>(null)

  const handleScroll = () => {
    const videoElement = videoRef.current
    if (!videoElement) return

    const rect = videoElement.getBoundingClientRect()
    const isWithin300px = rect.top >= 0 && rect.top <= 300

    if (isWithin300px) {
      videoElement.play()
    }
  }

  useEffect(() => {
    globalThis.window.addEventListener("scroll", handleScroll)

    return () => {
      globalThis.window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return isMobile ? (
    <div className="mx-[14px] mb-[64px] flex max-w-full flex-col items-center rounded-[24px] bg-white pt-[48px] lg_mx-auto">
      <h2 className="mb-[8px] w-[80%] text-center text-[24px] font-[700] leading-[28px] text-title lg_w-full">
        Spot food, effortlessly!{" "}
      </h2>
      <p className="mb-[24px] text-[14px] leading-[20px] text-[#3E3E3E]">
        360° Transparent visual grain bin.
      </p>

      <img src="/images/home-spot-food-mobile.webp" />
    </div>
  ) : (
    <div className="mx-auto mb-[120px] flex max-h-[720px] max-w-full overflow-hidden rounded-[28px] bg-white lg_w-[1360px]">
      <div className="flex flex-col justify-center lg_w-[570px] lg_pl-[120px]">
        <h2 className="mb-[8px] text-[24px] font-[700] leading-[28px] text-title lg_mb-[16px] lg_text-[48px] lg_leading-[58px]">
          Spot food, effortlessly!{" "}
        </h2>
        <p className="mb-[24px] text-[14px] leading-[20px] text-[#3E3E3E] lg_text-[24px] lg_leading-[28px]">
          360° Transparent visual grain bin.
        </p>
      </div>
      <div className="flex flex-1 justify-end">
        <video className="h-full w-auto pt-[48px] lg_pt-0" ref={videoRef} muted>
          <source src="/videos/feeder-add-food.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  )
}

export default SpotFood
